import React, { useState, useEffect, useMemo } from 'react';
import { Checkbox } from 'antd';
import { apiHolder as api, apis } from 'api';
import ScheduleDatePicker from '@web-schedule/components/FormComponents/ScheduleDatePicker';
import TimeStepPicker from '@web-schedule/components/TimeStepPicker/TimeStepPicker';
import Message from '@web-common/components/UI/Message/SiriusMessage';
import moment from 'moment';
import NiceModal, { createNiceModal, useNiceModal } from '@web-common/components/UI/NiceModal/NiceModal';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import './index.scss';
import { MailActions, MailTabActions, useActions, useAppSelector, useAppDispatch } from '@web-common/state/createStore';
import noneIcon from '@/images/icons/todomail/none.svg';
import oneIcon from '@/images/icons/todomail/one.svg';
import twoIcon from '@/images/icons/todomail/two.svg';
import nineteenIcon from '@/images/icons/todomail/nineteen.svg';
import nineIcon from '@/images/icons/todomail/nine.svg';
import tnineteenIcon from '@/images/icons/todomail/nineteen.svg';
import otherIcon from '@/images/icons/todomail/other.svg';
import { ReactComponent as DeleteIcon } from '@/images/icons/modal_close_temp.svg';
import { filterTabMap, FLOLDER } from '../../common/constant';
import { promiseIsTimeOut } from '@web-mail/util';
import { getIn18Text } from 'api';
const MailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const systemApi = api.api.getSystemApi();
const nimApi = api.api.requireLogicalApi('NIM');
const options = [
    { type: '0', title: getIn18Text('WU'), icon: noneIcon },
    { type: '1', title: getIn18Text('1XIAOSHIHOU'), icon: oneIcon },
    { type: '2', title: getIn18Text('2XIAOSHIHOU'), icon: twoIcon },
    { type: '3', title: getIn18Text('JINWAN 19'), icon: nineteenIcon },
    { type: '4', title: getIn18Text('MINGZAO 9:'), icon: nineIcon },
    { type: '5', title: getIn18Text('MINGWAN 19'), icon: tnineteenIcon },
    { type: '6', title: getIn18Text('QITASHIJIAN'), icon: otherIcon },
];
const TodoMail = () => {
    const [isRemind, setRemind] = useState(true);
    const [showIsRemind, setShowIsRemind] = useState(true);
    const [onActive, setActive] = useState('1');
    const [remindDate, setRemindDate] = useState();
    const modal = useNiceModal('mailTodo');
    const dispatch = useAppDispatch();
    const mailSearching = useAppSelector(state => state.mailReducer.mailSearching);
    const isSearching = useMemo(() => !!mailSearching, [mailSearching]);
    useEffect(() => {
        const visibleIM = nimApi.getIMAuthConfig();
        if (!visibleIM) {
            setShowIsRemind(false);
            setRemind(false);
        }
    }, []);
    useEffect(() => {
        if (modal.args.isDefer && modal.args.deferTime) {
            if (modal.args.deferTime.indexOf('2200') !== -1) {
                setActive('0');
                showIsRemind && setRemind(false);
            }
            else {
                setActive('6');
                if (moment(modal.args.deferTime, 'YYYY-MM-DD HH:mm:ss').valueOf() > new Date().getTime()) {
                    setRemindDate(moment(modal.args.deferTime, 'YYYY-MM-DD HH:mm:ss'));
                }
                else {
                    setRemindDate(moment().add(1, 'm'));
                }
                showIsRemind && setRemind(!!modal.args.deferNotice);
            }
        }
    }, [modal.args]);
    const optionClick = (type) => {
        if (type === '0') {
            setActive(type);
            showIsRemind && setRemind(false);
        }
        else if (type === '6') {
            setActive(type);
            setRemindDate(moment().add(1, 'm'));
        }
        else if (type === '3' && moment().valueOf() > moment('19:00', 'HH:mm').valueOf()) {
            Message.warning({ content: getIn18Text('BUNENGXUANZEGUO'), key: modal.args.mailId });
        }
        else {
            setActive(type);
            showIsRemind && setRemind(true);
        }
    };
    const Footer = () => {
        const { doUpdateSelectedKey, doUpdateMailTabs } = useActions(MailActions);
        const { doChangeCurrentTab } = useActions(MailTabActions);
        const onChange = (e) => {
            setRemind(e.target.checked);
        };
        const cancelRemind = () => {
            modal.hide();
        };
        const checkDefer = () => {
            doChangeCurrentTab('-1');
            doUpdateMailTabs(filterTabMap.defer);
            doUpdateSelectedKey({ id: FLOLDER.DEFER });
            Message.destroy(modal.args.mailId);
        };
        const submitRemind = async () => {
            let _remindDate;
            if (onActive === '0') {
                _remindDate = moment('2200-01-01 00:00:00', 'YYYY-MM-DD HH:mm:ss');
            }
            else if (onActive === '1') {
                _remindDate = moment().add(1, 'h');
            }
            else if (onActive === '2') {
                _remindDate = moment().add(2, 'h');
            }
            else if (onActive === '3') {
                _remindDate = moment().hour(19).minute(0).second(0);
            }
            else if (onActive === '4') {
                _remindDate = moment().add(1, 'd').hour(9).minute(0).second(0);
            }
            else if (onActive === '5') {
                _remindDate = moment().add(1, 'd').hour(19).minute(0).second(0);
            }
            else if (onActive === '6') {
                _remindDate = remindDate;
            }
            if (moment().valueOf() > _remindDate.valueOf()) {
                Message.warning({ content: getIn18Text('BUNENGXUANZEGUO'), key: modal.args.mailId });
                return;
            }
            setRemindDate(_remindDate);
            const res = await MailApi.doMarkMailDefer(modal.args.mailId, true, { deferTime: moment(_remindDate).valueOf(), deferNotice: isRemind });
            if (res && res.succ) {
                Message.success({
                    content: (React.createElement("span", null,
                        getIn18Text('SHEZHICHENGGONG\uFF0C11'),
                        React.createElement("span", { hidden: !systemApi.isMainPage() || isSearching, onClick: checkDefer, style: { color: '#386ee7', marginLeft: '24px', cursor: 'pointer' } }, getIn18Text('CHAKAN')))),
                    key: modal.args.mailId,
                });
                promiseIsTimeOut(dispatch(Thunks.refreshFolder({ noCache: true })), 'pc_refreshFolder_timeout', {
                    from: 'todoMail',
                });
            }
            else {
                Message.warning({ content: getIn18Text('CAOZUOSHIBAI\uFF0C11') });
            }
            modal.hide();
        };
        return (React.createElement("div", { className: "todo-mail-modal-footer" },
            React.createElement("div", { className: "btn-box" }, showIsRemind && (React.createElement(Checkbox, { checked: isRemind, onChange: onChange, disabled: onActive === '0' }, getIn18Text('TIXINGWOCHULI')))),
            React.createElement("div", { className: "btn-box" },
                React.createElement("p", { className: "cancel-btn btn", onClick: cancelRemind }, getIn18Text('QUXIAO')),
                React.createElement("p", { className: "submit-btn btn", onClick: submitRemind }, getIn18Text('QUEDING')))));
    };
    const Schedule = () => {
        const onChangeDate = (date) => {
            date && setRemindDate(date);
        };
        const filterPassedDate = (time) => {
            const currentDate = new Date();
            const selectedDate = new Date(time);
            return !moment(moment(selectedDate).format('YYYY-MM-DD')).isBefore(moment(currentDate).format('YYYY-MM-DD'));
        };
        const filterPassedTime = (time) => {
            const currentDate = new Date();
            const selectedDate = new Date(time);
            return currentDate.getTime() < selectedDate.getTime();
        };
        return (React.createElement("div", { className: "schedule-box", hidden: onActive !== '6' },
            React.createElement("span", { className: "schedule-title" }, getIn18Text('JIEZHISHIJIAN')),
            React.createElement(ScheduleDatePicker, { onKeyDown: (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                }, onChange: onChangeDate, allowClear: false, value: remindDate, className: "date-picker", filterDate: filterPassedDate }),
            React.createElement(TimeStepPicker, { onKeyDown: (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                }, onChange: onChangeDate, timeIntervals: 1, value: remindDate, className: "time-picker", filterTime: filterPassedTime })));
    };
    return (React.createElement(NiceModal, { id: "mailTodo", title: getIn18Text('SHEZHICHULISHI'), closeIcon: React.createElement(DeleteIcon, { className: "dark-invert" }), footer: React.createElement(Footer, null), width: "464px", className: "todo-mail-modal" },
        React.createElement("div", { className: "modal-body" }, options.map(i => (React.createElement("div", { className: i.type === onActive ? 'option-item-active option-item' : 'option-item', onClick: () => optionClick(i.type), key: i.type },
            React.createElement("img", { src: i.icon, alt: i.title }),
            React.createElement("p", null, i.title))))),
        React.createElement(Schedule, null)));
};
const MailTodoModal = createNiceModal('mailTodo', TodoMail);
export default MailTodoModal;
